import { FC } from 'react';

import { ITextAreaProps } from './types';
import { TextInput } from '../TextInput';

export const TextArea: FC<ITextAreaProps> = ({
  width = '400px',
  initialHeight = '150px',
  ...props
}) => {
  return (
    <TextInput
      {...props}
      as="textarea"
      width={width}
      style={{
        minHeight: initialHeight,
      }}
    />
  );
};
